import { Component, ReactNode } from 'react';
import { UnexpectedErrorPage } from './UnexpectedErrorPage';
import { handleError } from '@/lib/error';

interface Props {
  children: ReactNode;
  resetKey?: string;
  pathname?: string | null;
  resetError: () => void;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // Log the error to the server
    handleError(error, { 
      componentStack: errorInfo.componentStack
    });
  }

  componentDidUpdate(prevProps: Props) {
    if (
      (prevProps.pathname !== this.props.pathname || prevProps.resetKey !== this.props.resetKey) &&
      this.state.hasError
    ) {
      this.setState({ hasError: false });
    }
  }

  resetError = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return <UnexpectedErrorPage resetError={this.resetError} />;
    }
    return this.props.children;
  }
}
